import { useAuth } from "../context/auth-context";

/** Resolve audit actor id for createdBy / updatedBy / userId from the signed-in user. */
export const useAuditUserId = (): string => {
  const { user } = useAuth() as {
    user: { profile?: { sub?: string; Name?: string } } | null;
  };

  if (user?.profile?.sub) return user.profile.sub;
  if (user?.profile?.Name) return String(user.profile.Name).replace(/,/g, "");
  return "admin";
};
